import { a as __rest } from '../../_tslib.esm.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { simulateButtonKeyboardBehavior } from '../../testUtils/buttonKeyboardBehavior.esm.js';
import buttonStyles from './Button.styles.esm.js';

/**
 * Button component communicates an action will occur, like advancing to the next page, or saving information. Button labels clearly describe the action they trigger.
 */
const Button = forwardRef((_a, ref) => {
  var {
      variant = "primary",
      size = "md",
      className = "",
      children,
      onClick,
      inverse = false,
      disabled = false,
      icon,
      iconPosition = "left",
      href
    } = _a,
    props = __rest(_a, ["variant", "size", "className", "children", "onClick", "inverse", "disabled", "icon", "iconPosition", "href"]);
  const hasHref = Boolean(href);
  const hasIcon = Boolean(icon);
  const isDisabledAnchor = hasHref && disabled;
  const {
    base: baseClasses,
    hasIcon: iconClasses
  } = buttonStyles({
    size,
    variant,
    inverse,
    disabled,
    iconPosition,
    class: className
  });
  const Component = href ? "a" : "button";
  const componentProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    ref,
    className: "iris:font-(family-name:--comp-type-font-button) " + baseClasses({
      class: className
    })
  }, !hasHref && {
    disabled
  }), hasHref && !disabled && {
    href,
    onKeyDown: simulateButtonKeyboardBehavior(onClick)
  }), isDisabledAnchor && {
    role: "link",
    "aria-disabled": true,
    onClick: e => e.preventDefault()
  }), !isDisabledAnchor && {
    onClick
  }), props);
  const renderContent = () => {
    if (!hasIcon) return children;
    const iconElement = jsx("span", {
      className: iconClasses(),
      children: icon
    });
    return iconPosition === "left" ? jsxs(Fragment, {
      children: [iconElement, children]
    }) : jsxs(Fragment, {
      children: [children, iconElement]
    });
  };
  return jsx(Component, Object.assign({}, componentProps, {
    children: renderContent()
  }));
});

export { Button };
